import React from 'react';
import { Smile, Shield, ArrowRight } from 'lucide-react';
import './Services.css';

function EmmipetDental() {
  return (
    <>
      <section className="page-hero">
        <div className="page-hero__bg">
          <img src="/images/dental.jpg" alt="Emmipet dental treatment" />
          <div className="page-hero__overlay" />
        </div>
        <div className="page-hero__content container">
          <span className="section-label" style={{ color: 'var(--color-accent-light)' }}>Dental Care</span>
          <h1 className="page-hero__title">Emmipet Dental Treatments</h1>
          <p className="page-hero__subtitle">
            Oral health is a vital part of your dog&rsquo;s overall wellbeing.
          </p>
        </div>
      </section>

      <section className="services-intro section">
        <div className="container">
          <div className="services-intro__content">
            <p>
              At Tails &amp; Tweed, we offer Emmi-Pet ultrasonic dental treatments &mdash; a
              non-invasive, vibration-free system designed to support gum health, reduce plaque
              build-up, and improve oral hygiene without the need for anaesthetic.
            </p>
            <p>
              Delivered in a calm, structured environment, our approach prioritises tolerance,
              patience and long-term maintenance.
            </p>
            <a
              href="https://app.toplinedogs.co.uk/public/online-bookings?salon=YWJmZDE4NjAtMWMzZi00NjMyLTkyNTQtMDhkOWI2OGFiZGUx"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-accent"
              style={{ marginTop: 24 }}
            >
              Book Now
            </a>
          </div>
        </div>
      </section>

      <section className="services section" style={{ paddingTop: 0 }}>
        <div className="container">
          <div className="services__list">
            <div className="service-detail">
              <div className="service-detail__image">
                <img src="/images/dental.jpg" alt="Emmipet ultrasonic dental" />
              </div>
              <div className="service-detail__content">
                <div className="service-detail__icon">
                  <Smile size={28} />
                </div>
                <h2 className="service-detail__title">What is Emmi-Pet?</h2>
                <p className="service-detail__text">
                  Emmi-Pet uses ultrasonic technology to:
                </p>
                <ul className="service-detail__features">
                  <li>Help break down plaque and tartar</li>
                  <li>Reduce harmful bacteria in the mouth</li>
                  <li>Support gum health</li>
                  <li>Improve breath odour</li>
                  <li>Maintain oral hygiene between veterinary cleans</li>
                </ul>
                <p className="service-detail__text" style={{ marginTop: 16 }}>
                  The treatment is:
                </p>
                <ul className="service-detail__features">
                  <li>Silent</li>
                  <li>Non-invasive</li>
                  <li>Anaesthetic free</li>
                </ul>
                <p className="service-detail__note">
                  It works through ultrasonic waves rather than mechanical brushing, making it
                  suitable for many dogs who would not tolerate traditional methods.
                </p>
              </div>
            </div>

            <div className="service-detail service-detail--reverse">
              <div className="service-detail__image">
                <img src="/images/dog-golden.jpg" alt="Dog dental assessment" />
              </div>
              <div className="service-detail__content">
                <div className="service-detail__icon">
                  <Shield size={28} />
                </div>
                <h2 className="service-detail__title">Who Is It Suitable For?</h2>
                <p className="service-detail__text">
                  As with all services at Tails &amp; Tweed, welfare comes first. We assess:
                </p>
                <ul className="service-detail__features">
                  <li>Your dog&rsquo;s temperament</li>
                  <li>Oral condition</li>
                  <li>Tolerance levels</li>
                </ul>
                <p className="service-detail__text" style={{ marginTop: 16 }}>
                  Some dogs adapt quickly. Others require gradual introduction sessions. We work
                  patiently and never force compliance.
                </p>
                <p className="service-detail__note">
                  If dental disease is advanced, we will always advise referral to your veterinary surgeon.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="page-cta">
        <div className="container">
          <div className="page-cta__inner">
            <div className="page-cta__content">
              <h2>Book a Dental Treatment</h2>
              <p>Add Emmipet dental cleaning to your pet&rsquo;s routine grooming schedule.</p>
            </div>
            <div className="page-cta__actions">
              <a
                href="https://app.toplinedogs.co.uk/public/online-bookings?salon=YWJmZDE4NjAtMWMzZi00NjMyLTkyNTQtMDhkOWI2OGFiZGUx"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-accent"
              >
                Book Now <ArrowRight size={16} />
              </a>
              <a href="tel:07904813567" className="btn btn-outline" style={{ borderColor: 'var(--color-white)', color: 'var(--color-white)' }}>
                Call Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default EmmipetDental;
